import React from 'react';
import YouTubeWalkthroughEmbed from './YouTubeWalkthroughEmbed';
import {
  getWalkthroughVideo,
  type WalkthroughVideoKey,
} from '../../config/walkthroughVideos';

type ProductDemoVideoEmbedProps = {
  videoKey: WalkthroughVideoKey;
  className?: string;
};

export default function ProductDemoVideoEmbed({
  videoKey,
  className = '',
}: ProductDemoVideoEmbedProps) {
  const video = getWalkthroughVideo(videoKey);

  return (
    <div
      className={`relative w-full aspect-[4/3] min-h-[400px] sm:min-h-[500px] lg:min-h-[560px] bg-slate-900 overflow-hidden ${className}`}
    >
      <YouTubeWalkthroughEmbed
        video={video}
        autoLoad
        className="absolute inset-0 h-full w-full rounded-none border-0 shadow-none ring-0"
      />
    </div>
  );
}
